<!--  -->
<template>
  <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">文旅资讯</a>
        <span>&gt;</span>
        <a href="#">详情页</a>
      </div>
    </div> -->
    <div class="venueTime">
    <section class="srv-time-selector" v-show="switchShow">
      <div class="bd">
          <div class="header">
            <div class="data-picker">
              <div class="wrapper">
                <!-- 上月 -->
               <button ref="btn" v-for="(date, index) in dates.nowMonth" :key="'g'+date.id" :id="'scroll-' + index" :class="[{current: date.current}, {'appointment': !date.appointment}]" @click="selectedNow(index, $event)">
              <span v-html="date.ddate"></span>
              <span>{{date.appointment ? '可预约' : '暂不可约'}}</span>
              </button>
              <!-- 下月 -->
              <button ref="btn" v-for="(date, index) in dates.nextMonth" :key="'h'+ date.id" :id="'scroll-next-' + index" :class="[{current: date.current}, {'appointment': !date.appointment}]" @click="selectedNext(index, $event)">
              <span v-html="date.ddate"></span>
              <span>{{date.appointment ? '可预约' : '暂不可约'}}</span>
          </button>
              </div>
            </div>
            <button class="cal" @click="changeTab">
              <img src="../../assets/common/images/calendar.png" alt="">
            </button>
          </div>
          <div class="hours" v-if="!isSectionFlag">
            <!-- 本月 -->
            <div class="wrapper" v-for="date in dates.nowMonth" :key="'i'+date.id" v-if="date.current && date.appointment">
              <div :class="{'chose-time': !isChoseTime}" v-if="isFirstDay === 0">
              <button ref="littlebtn"  :class="['hour-this', {'not-can-use': parseFloat((key + 13)/2) <= currentHours}]" v-for="(hour, key) in date.hours" :key="'c'+key" @click="timeChose(key, $event);getChoose($event)" v-html="hour.hour"></button>
            </div>
            <div :class="{'chose-time': !isChoseTime}" v-else>
              <button ref="littlebtn" class="hour-this" v-for="(hour, key) in date.hours" :key="'d'+key" @click="timeChose(key, $event);getChoose($event)" v-html="hour.hour"></button>
            </div>
            </div>
              <div class="wrapper" v-else-if="date.current && !date.appointment">
                  <div class="tips">
                    <img class="null-tips" src="../../assets/common/images/baoqian_weici2_icon.png" alt="" />
                    <p>抱歉，今天的服务暂时不能预约哦~</p>
                  </div>
            </div>

            <!-- 下月 -->
        <div class="wrapper" v-for="date in dates.nextMonth" :key="'f'+date.id" v-if="date.current && date.appointment">

        <div :class="{'chose-time': !isChoseTime}">
          <button ref="littlebtn" class="hour-this" v-for="(hour, key) in date.hours" :key="'e'+key" @click="timeChose(key, $event);getChoose($event)" v-html="hour.hour"></button>
        </div>
      </div>
      <div class="wrapper" v-else-if="date.current && !date.appointment">
        <div class="tips">
          <img class="null-tips" src="../../assets/common/images/baoqian_weici2_icon.png" alt="" />
          <p>抱歉，今天的服务暂时不能预约哦~</p>
        </div>
      </div>

          </div>

          <!-- <%--分段预约 是--%> -->
    <div class="hours" v-if="isSectionFlag">
      <!--本月-->
      <div class="wrapper" v-for="date in dates.nowMonth" :key="'j'+date.id" v-if="date.current && date.appointment">
        <div class="btncenter">
            <button class="hour-this mjs" ref="littlebtn" @click="getChoose($event)" v-for="(item,index) in timeData" :key="'k'+index">{{item.startTime}}-{{item.endTime}}</button>
        </div>
      </div>
      <div class="wrapper" v-else-if="date.current && !date.appointment">
        <div class="tips">
          <img class="null-tips" src="../../assets/common/images/baoqian_weici2_icon.png" alt="" />
          <p>抱歉，今天的服务暂时不能预约哦~</p>
        </div>
      </div>
      <!--下月-->
      <div class="wrapper" v-for="date in dates.nextMonth" :key="'l'+date.id" v-if="date.current && date.appointment">
        <div class="btncenter">
              <button class="hour-this mjs" ref="littlebtn" @click="getChoose($event)" v-for="(item,index) in timeData" :key="'m'+index">{{item.startTime}}-{{item.endTime}}</button>
        </div>
      </div>
      <div class="wrapper" v-else-if="date.current && !date.appointment">
        <div class="tips">
          <img class="null-tips" src="../../assets/common/images/baoqian_weici2_icon.png" alt="" />
          <p>抱歉，今天的服务暂时不能预约哦~</p>
        </div>
      </div>
    </div>

          <div class="line"></div>

          <p class="ps">
            <img src="../../assets/common/images/ps.png" alt="">预约时间若为灰色，则表示该时段已被预约，请另行选择。
          </p>
          <div class="out" @click="submitTime">确定</div>
      </div>

    </section>

      <section class="srv-time-selector" v-show="!switchShow">
  <div class="bd">
    <section class="days-component">
      <div class="weekdays">
        <div class="weekday">日</div>
        <div class="weekday">一</div>
        <div class="weekday">二</div>
        <div class="weekday">三</div>
        <div class="weekday">四</div>
        <div class="weekday">五</div>
        <div class="weekday">六</div>
      </div>
      <div class="days-body">
        <div>
          <div class="days">
            <div class="day" v-for="(day,i) in nullDay" :key="'b'+i" v-text="day"></div>
            <div class="day" v-for="(date, index) in dates.nowMonth" :key="'n'+index" :id="'scroll-' + index" :class="[{current: date.current}, {'appointment': !date.appointment}]" @click="selectedNow(index, $event)">
              <span>{{date.appointment ? '' : '暂不可约'}}</span>
              <a href="javascript:;" v-html="date.day"></a>
            </div>
          </div>
          <div class="month">{{currentYears}}年{{currentMonth + 1}}月</div>
          <div class="days">
            <div class="day" v-for="(day,index) in nextNullDay" :key="index">{{day}}</div>
            <div class="day" v-for="(date, index) in dates.nextMonth" :key="'o'+index" :id="'scroll-next-' + index" :class="[{current: date.current}, {'appointment': !date.appointment}]" @click="selectedNext(index, $event)">
              <span>{{date.appointment ? '' : '暂不可约'}}</span>
              <a href="javascript:;" v-html="date.day"></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>
</div>

</template>

<script>
import {getTime} from '@/utils/validate'
import { getvenueTime, nocanuse } from '@/api/venue/index'
export default {
  name: 'venuetime',
  components: {

  },
  props: ['id', 'menuId'],
  data () {
    return {
      totalday: 30,
      date1: getTime(),
      isFirstDay: 0,
      hours: [ {
        'hour': '06:30-07:00'
      }, {
        'hour': '07:00-07:30'
      }, {
        'hour': '07:30-08:00'
      }, {
        'hour': '08:00-08:30'
      }, {
        'hour': '08:30-09:00'
      }, {
        'hour': '09:00-09:30'
      }, {
        'hour': '09:30-10:00'
      }, {
        'hour': '10:00-10:30'
      }, {
        'hour': '10:30-11:00'
      }, {
        'hour': '11:00-11:30'
      }, {
        'hour': '11:30-12:00'
      }, {
        'hour': '12:00-12:30'
      }, {
        'hour': '12:30-13:00'
      }, {
        'hour': '13:00-13:30'
      }, {
        'hour': '13:30-14:00'
      }, {
        'hour': '14:00-14:30'
      }, {
        'hour': '14:30-15:00'
      }, {
        'hour': '15:00-15:30'
      }, {
        'hour': '15:30-16:00'
      }, {
        'hour': '16:00-16:30'
      }, {
        'hour': '16:30-17:00'
      }, {
        'hour': '17:00-17:30'
      }, {
        'hour': '17:30-18:00'
      }, {
        'hour': '18:00-18:30'
      }, {
        'hour': '18:30-19:00'
      }, {
        'hour': '19:00-19:30'
      }, {
        'hour': '19:30-20:00'
      }, {
        'hour': '20:00-20:30'
      }, {
        'hour': '20:30-21:00'
      }, {
        'hour': '21:00-21:30'
      }, {
        'hour': '21:30-22:00'
      }, {
        'hour': '22:00-22:30'
      }, {
        'hour': '22:30-23:00'
      }
      ],
      timeData: [ {
        day: getTime(),
        startTime: '9:00',
        endTime: '18:00'
      } ],
      // id: 0,
      switchShow: true,
      currentYears: '',
      currentMonth: '',
      currentDay: '',
      currentHours: '',
      cycle: '',
      dates: {
        nowMonth: [],
        nextMonth: []
      },
      nullDay: [],
      nextNullDay: [],
      nextProtoWeek: null,
      isChoseTime: true,
      isChoseTimeShow: true,
      isSectionFlag: '',
      isTimeSection: '',
      daytext: '',
      dateflag: '',
      chosedArr: [],
      submitTimeStr0: '',
      submitTimeStr1: '',
      splitarr1: [],
      splitarr2: [],
      splitArr3: []
    }
  },
  created () {
    // 接口获取时间数据
  // this.id = this.$route.query.id
    this.getvenueTimeInfo(this.id)
    setTimeout(this.getReady, 1000)
  // this.getReady()
  },
  mounted () {
    console.log(this.$refs.btn)
    this.$refs.btn.forEach((item, index) => {
      if (item.className.indexOf('current') >= 0) {
        console.log(item.getElementsByTagName('span')[0].innerText)
        var daytext = item.getElementsByTagName('span')[0].innerText
        this.daytext = daytext
      }
    })

    var tempday1 = this.daytext.substr(3, this.daytext.length)
    var days = this.$refs.littlebtn
    console.log(days)

    var monthday = tempday1.substr(0, tempday1.length - 3)
    var riday = tempday1.substr(2, tempday1.length)
    var cuday = this.currentYears + '-' + monthday + '-' + riday //eslint-disable-line
    for (var i = 0; i < this.timeData.length; i++) {
	    var startTime = this.timeData[i].startTime//eslint-disable-line
      var endTime = this.timeData[i].endTime//eslint-disable-line
      var year = this.timeData[i].day.substr(0, 4)
      if (this.isTimeSection == 0) {//eslint-disable-line
        if (this.timeData[i].day == cuday && this.currentYears == year) { //eslint-disable-line
          for (var j = 0; j < days.length; j++) {
            var thisTime = days[j].innerText
            var thisstart = thisTime.split('-')[0] //eslint-disable-line
            var thisend = thisTime.split('-')[1]
            if (this.compareDate(thisend, endTime) == true || this.compareDate(thisend, startTime) == false) {//eslint-disable-line
              days[j].classList.add('not-can-use')
              //  console.log(days[j].classList)
            }
          }
        }
      } else {
        if (this.date1 == cuday && this.currentYears == year) {  //eslint-disable-line
          for (var k = 0; k < days.length; k++) {
            var thisTime1 = days[k].innerText
            var thisstart1 = thisTime1.split('-')[0]
            var thisend1 = thisTime1.split('-')[1]
            if (this.compareDate(this.date1, thisstart1) == true && this.compareDate(this.date1, thisend1) == true) { //eslint-disable-line
              days[j].classList.add('not-can-use')
            }
          }
        }
      }
    }
  },
  updated () {
    this.$refs.btn.forEach((item, index) => {
      if (item.className.indexOf('current') >= 0) {
        // console.log(item.getElementsByTagName('span')[0].innerText)
        var daytext = item.getElementsByTagName('span')[0].innerText
        this.daytext = daytext
      }
    })

    var tempday1 = this.daytext.substr(3, this.daytext.length)
    var days = this.$refs.littlebtn
    // console.log(days)

    var monthday = tempday1.substr(0, tempday1.length - 3)
    var riday = tempday1.substr(2, tempday1.length)
    var cuday = this.currentYears + '-' + monthday + '-' + riday //eslint-disable-line

    for (var i = 0; i < this.timeData.length; i++) {
      var startTime = this.timeData[i].startTime
      var endTime = this.timeData[i].endTime
      var year = this.dateflag.substr(0, 4)
      if (this.isTimeSection == 0) { //eslint-disable-line
          if (this.dateflag == cuday && this.currentYears == year) {//eslint-disable-line
          for (var j = 0; j < days.length; j++) {
            var thisTime = days[j].innerText
            var thisstart = thisTime.split('-')[0] //eslint-disable-line
            var thisend = thisTime.split('-')[1]
            if (this.compareDate(thisend, endTime) == true || this.compareDate(thisend, startTime) == false) {//eslint-disable-line
              days[j].classList.add('not-can-use')
              //  console.log(days[j].classList)
            }
          }
        }
      } else {
      if (this.date1 == cuday && this.currentYears == year) {  //eslint-disable-line
          for (var k = 0; k < days.length; k++) {
            var thisTime1 = days[k].innerText
            var thisstart1 = thisTime1.split('-')[0]
            var thisend1 = thisTime1.split('-')[1]
            if (this.compareDate(this.date1, thisstart1) == true && this.compareDate(this.date1, thisend1) == true) { //eslint-disable-line
              days[j].classList.add('not-can-use')
            }
          }
        }
      }
    }
  },

  methods: {

    getvenueTimeInfo (id) {
      getvenueTime(id).then(res => {
        console.log(res)
        this.isTimeSection = res.data.data.isTimeSection
        if (res.data.data.isTimeSection == 0) { //eslint-disable-line
          res.data.data['day'] = getTime()
          this.timeData = [res.data.data]
          this.cycle = res.data.data.cycle

          //  以下为筛选时间段，不显示多余的时间段
          this.splitarr1 = this.hours.filter(item => {
            return item.hour.split('-')[0].split(':')[0] >= res.data.data.startTime.split(':')[0]
          })

          this.splitarr2 = this.hours.filter(item => {
            return item.hour.split('-')[0].split(':')[0] <= res.data.data.endTime.split(':')[0]
          })

          this.splitarr1.forEach(item => {
            this.splitarr2.forEach(val => {
              if (val === item) {
                this.splitArr3.push(val)
              }
            })
          }) // 筛选结束
        } else {
          res.data.data.timeSectionData.forEach(item => {
            item['day'] = getTime()
          })
          this.timeData = res.data.data.timeSectionData
          this.cycle = res.data.data.cycle
        }
      })

      return this.cycle
    },
    getReady () {
       if (this.isTimeSection == 0) {//eslint-disable-line
        this.isSectionFlag = false
      } else {
        this.isSectionFlag = true
      }
      var date = new Date()
      var currentYears = date.getFullYear()
      var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      var currentMonth = date.getMonth() + 1
      var currentDay = date.getDate()
      var protoWeek = date.getDay()
      var currentHours = date.getHours()
      var currentMinutes = date.getMinutes()
      var hours = this.splitArr3
      if (currentMinutes >= 30) {
        currentHours += 0.5
      }
      this.currentYears = currentYears
      this.currentMonth = currentMonth
      this.currentDay = currentDay
      this.currentHours = currentHours
      for (var i = 0; i < this.totalday; i++) {
        var month = date.getMonth() + 1
        var day = date.getDate()
        var proteWeek = date.getDay()
        var timestamp = date.getTime()
        // var appointment = true
        var ddate = week[proteWeek] + ' ' + month + '-' + day
        var nextdate = week[proteWeek] + ' ' + parseInt(month + 1) + '-' + day
        var appointment = false
        console.log(this.cycle, 'mmm')

        if (this.cycle.indexOf(proteWeek) >= 0) {
          appointment = true
        }
        var d = {
          'id': 'a' + i,
          'timestamp': timestamp,
          'appointment': appointment,
          'month': month,
          'day': day,
          'proteWeek': proteWeek,
          'week': week[proteWeek],
          'hours': hours,
          'current': false,
          'ddate': ddate,
          'nextdate': nextdate

        }
      if (month == currentMonth) {//eslint-disable-line
          this.dates.nowMonth.push(d)
        } else {
          this.dates.nextMonth.push(d)
        }
        date.setDate(date.getDate() + 1)
      }

      this.dates.nowMonth[0].current = true
      this.nextProtoWeek = this.dates.nextMonth[0].proteWeek

      for (var j = 0; j < protoWeek; j++) {
        this.nullDay.push('')
      }
      for (var k = 0; k < this.nextProtoWeek; k++) {
        this.nextNullDay.push('')
      }

      this.dateflag = new Date().getFullYear() + '-' + this.dates.nowMonth[0].month + '-' + this.dates.nowMonth[0].day// 日期赋值

      setTimeout(this.getnotuse(), '100')
    },
    getChoose (e) {
      setTimeout(this.getnotuse(), '100')
      e.currentTarget.classList.toggle('chosed')
      // console.log(this.$refs.littlebtn)

      this.chosedArr = this.$refs.littlebtn.filter((item) => {
        return item.className.indexOf('chosed') >= 0
      })
      var start = this.chosedArr[0].innerText
      // console.log(start)
      var end = this.chosedArr[this.chosedArr.length - 1].innerText
      if (start != end && this.isTimeSection == 0) {//eslint-disable-line
        var chosed = false
        this.$refs.littlebtn.forEach(item => {
                  if (chosed == true && item.className.indexOf('not-can-use') >= 0) {//eslint-disable-line
            alert('选中时间区有不允许预约时间段，请确认!')
          }
                  if (item.innerText == start) { //eslint-disable-line
            chosed = true
          }
                  if (item.innerText == end) { //eslint-disable-line
            chosed = false
          }
                  if (chosed == true) { //eslint-disable-line
            item.classList.add('chosed')
          }
        })
      }
    },
    submitTime () {
      if (this.isTimeSection == 1) { //eslint-disable-line
        var arr = this.$refs.littlebtn.filter((item) => {
          return item.className.indexOf('chosed') >= 0
        })

        var arr1 = []
        arr.forEach(item => {
          arr1.push(item.innerText)
        })
        var stringtime = arr1.join(',')

        this.$refs.btn.forEach((item, index) => {
          if (item.className.indexOf('current') >= 0) {
            var daytext = item.getElementsByTagName('span')[0].innerText
            var tempday = daytext.substr(3, this.daytext.length)
            console.log()
            this.submitTimeStr1 = this.currentYears + '-' + tempday + ' ' + stringtime
          }
        })
        if (arr.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择时间'
          })
        } else {
          this.$emit('passTime', [this.submitTimeStr1, false])
        }
      } else {
        var cho = this.$refs.littlebtn.filter((item) => {
          return item.className.indexOf('chosed') >= 0
        })
        if (cho.length === 0) {
          var line = ''
        } else {
          line = cho[0].innerText.split('-')[0] + '-' + cho[cho.length - 1].innerText.split('-')[1]
        }

        this.$refs.btn.forEach((item, index) => {
          if (item.className.indexOf('current') >= 0) {
            var daytext = item.getElementsByTagName('span')[0].innerText
            var tempday = daytext.substr(3, this.daytext.length)
            this.submitTimeStr0 = this.currentYears + '-' + tempday + ' ' + line
            console.log(this.submitTimeStr0)
          }
        })
        if (cho.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择时间'
          })
        } else {
          this.$emit('passTime', [this.submitTimeStr0, false])
        }
      }
    },
    changeTab () {
      this.switchShow = !this.switchShow
    },
    compareDate: function (t1, t2) { // 比较时间大小
      var date = new Date()
      var a = t1.split(':')
      var b = t2.split(':')
      return date.setHours(a[0], a[1]) >= date.setHours(
        b[0], b[1])
    },
    selectedNow: function (index, event) {
      for (var i in this.dates.nowMonth) {
        this.dates.nowMonth[i].current = false
      }
      for (i in this.dates.nextMonth) {
        this.dates.nextMonth[i].current = false
      }
      if (!this.dates.nowMonth[index].appointment) {
        this.isChoseTimeShow = false
      } else {
        this.isChoseTimeShow = true
        this.isChoseTime = true
      }
      this.isFirstDay = index
      this.tableHide()
      this.dates.nowMonth[index].current = true

      this.dateflag = new Date().getFullYear() + '-' +
      this.dates.nowMonth[index].month +
      '-' +
      this.dates.nowMonth[index].day// 日期赋值

      setTimeout(this.getnotuse(), '100')
    },
    selectedNext: function (index, event) {
      for (var date in this.dates.nextMonth) {
        this.dates.nextMonth[date].current = false
      }
      for (date in this.dates.nowMonth) {
        this.dates.nowMonth[date].current = false
      }
      if (!this.dates.nextMonth[index].appointment) {
        this.isChoseTimeShow = false
      } else {
        this.isChoseTimeShow = true
        this.isChoseTime = true
      }
      this.isChoseTime = true
      this.tableHide()
      this.dates.nextMonth[index].current = true

      // eslint-disable-next-line no-tabs
      this.dateflag =	new Date().getFullYear() + '-' +
      this.dates.nextMonth[index].month +
      '-' +
      this.dates.nextMonth[index].day// 日期赋值
      if (new Date().getMonth() + 1 == 12) {  //eslint-disable-line
        // eslint-disable-next-line no-tabs
        this.dateflag =	new Date().getFullYear() +
        1 +
        '-' +
        this.dates.nextMonth[index].month +
        '-' +
        this.dates.nextMonth[index].day
      }

      setTimeout(this.getnotuse(), '100')
    },
    tableHide: function () {
      this.switchShow = true
    },
    timeChose: function (key, e) {
      this.isChoseTime = false
      // e.currentTarget
    },
    getnotuse () {
      var notparams = {
        venueTime: this.dateflag,
        venueId: this.id,
        menuId: this.menuId
      }
      nocanuse(notparams).then(res => {
        console.log(res, 'notuse')

        res.data.data.forEach(item => {
          if (this.isTimeSection === 0) {
            var key = false
            var starttime = item.venueTime.split(' ')[1].split('-')[0]
            var endtime = item.venueTime.split(' ')[1].split('-')[1]
            console.log(item.venueTime.split(' ')[1].split('-'))
            console.log(starttime, endtime)

            this.$refs.littlebtn.forEach(value => {
              if (value.innerText.indexOf(starttime) === 0) {
                key = true
              }
              if (value.innerText.indexOf(endtime) === 0) {
                key = false
              }
              if (key === true) {
                value.classList.add('not-can-use')
              }
            })
          } else {
            var alreadyvenue = item.venueTime.split(' ')[1].split(',')
            let rightNowDate = new Date()
            let rightnowHour = rightNowDate.getHours()
            this.$refs.littlebtn.forEach(right => {
              if (right.innerText.split(' ')[0].split('-')[1].split(':')[0] < rightnowHour) {
                right.classList.add('not-can-use')
              }
            })
            alreadyvenue.forEach(demo => {
              this.$refs.littlebtn.forEach(its => {
                if (its.innerText === demo) {
                  its.classList.add('not-can-use')
                }
              })
            })
          }
        })
      })
    }
  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/_venueChoosetime.scss";
</style>



// WEBPACK FOOTER //
// src/components/venueTime/index.vue